import { render, staticRenderFns } from "./CurriculumSpecific.vue?vue&type=template&id=7cb95098&"
import script from "./CurriculumSpecific.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSpecific.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSpecific.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VSelect})
